<div class="filter-container">
  <app-button [button]="showFiltersButton"> </app-button>
</div>

<ng-container *ngIf="noAppointment && !loading; else appointmentList">
  <div class="no-appoint-message">
    <div>No Appointments Found!</div>
  </div>
</ng-container>

<ng-template #appointmentList>
  <div class="appointment-container" *ngIf="!loading">
    <app-card [items]="cards"></app-card>

    <div class="load-more-container" *ngIf="!isListEmpty">
      <app-button [button]="loadMoreButton"> </app-button>
    </div>
  </div>
</ng-template>

<!--Shimmer-->
<div class="shimmer-container">
  <ng-container *ngIf="loading">
    <div class="shimmer-container">
      <app-shimmer
        [type]="shimmerTypeSMCard"
        *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
      ></app-shimmer>
    </div>
  </ng-container>
</div>

<!--Filters-->
<app-filter [items]="filterItems" [showClearAll]="false"> </app-filter>
